import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import SquareFootageToolView from "./squareFootageToolView";

const FakeOfflineSqft = (props) => {

  const {isSquareFootageEnabled, visualizersLoadedLength} = props;
  const [showFake, setShowFake] = useState(document.kvConfig.offlineMode || window.location.href.includes("offlineMode"));

  useEffect (() => {
    if (visualizersLoadedLength && showFake) {
      setTimeout(() => {
        setShowFake(false);
      }, 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[visualizersLoadedLength]);

  // other popups, modals and so on

  if (!showFake) {
    return null
  }

  return (
    <div className="base-sqft-fake">
      {isSquareFootageEnabled ? <SquareFootageToolView/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded} = store.serverState;
  return {
    visualizersLoadedLength: visualizersLoaded.length,
    isSquareFootageEnabled: store.sqftState.isSquareFootageEnabled,
  };
};

export default connect(mapStateToProps)(FakeOfflineSqft)
